import { create } from "zustand";
import { CommonsCell } from "../types";

interface AppState {
  deviceHash?: string;
  attest?: string;
  roomId: string;
  consented: boolean;
  wsState: "offline" | "connecting" | "live" | "error";
  commons: CommonsCell[];
  lastError?: string;
  setDeviceHash: (deviceHash: string) => void;
  setAttest: (attest: string) => void;
  setConsented: (consented: boolean) => void;
  setRoomId: (roomId: string) => void;
  setWsState: (wsState: AppState["wsState"]) => void;
  setCommons: (commons: CommonsCell[]) => void;
  mergeCommonsPatch: (patch: CommonsCell[]) => void;
  setLastError: (lastError?: string) => void;
}

const rememberedConsent = localStorage.getItem("afterglow-atlas.v1.consented") === "yes";
const rememberedRoom = localStorage.getItem("afterglow-atlas.v1.room") || "commons";

export const useAppStore = create<AppState>((set, get) => ({
  roomId: rememberedRoom,
  consented: rememberedConsent,
  wsState: "offline",
  commons: [],
  setDeviceHash: (deviceHash) => set({ deviceHash }),
  setAttest: (attest) => set({ attest }),
  setConsented: (consented) => {
    localStorage.setItem("afterglow-atlas.v1.consented", consented ? "yes" : "no");
    set({ consented });
  },
  setRoomId: (roomId) => {
    localStorage.setItem("afterglow-atlas.v1.room", roomId);
    set({ roomId });
  },
  setWsState: (wsState) => set({ wsState }),
  setCommons: (commons) => set({ commons }),
  mergeCommonsPatch: (patch) => {
    const byIndex = new Map(get().commons.map((cell) => [cell.i, cell]));
    for (const cell of patch) {
      const existing = byIndex.get(cell.i) || { i: cell.i, dwellMs: 0, touches: 0, visits: 0 };
      byIndex.set(cell.i, {
        i: cell.i,
        dwellMs: existing.dwellMs + cell.dwellMs,
        touches: existing.touches + cell.touches,
        visits: existing.visits + cell.visits,
        sessions: Math.max(existing.sessions || 0, cell.sessions || 0)
      });
    }
    set({ commons: Array.from(byIndex.values()).sort((a, b) => a.i - b.i) });
  },
  setLastError: (lastError) => set({ lastError })
}));
